import { useState } from "react";
import { NavLink } from "react-router-dom";
import * as Dialog from "@radix-ui/react-dialog";
import { Menu, X } from "lucide-react";
import { t } from "@/lib/i18n";
import { BirdMark } from "@/components/Logo";
import LangSwitcher from "@/components/LangSwitcher";

export default function MobileMenu({ items }) {
  const [open, setOpen] = useState(false);
  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger
        className="lg:hidden inline-flex items-center justify-center h-12 w-12 rounded-full text-forest hover:bg-cream-2 transition-colors"
        aria-label={t("nav.menu")}
        data-testid="mobile-menu-open-button"
      >
        <Menu className="h-6 w-6" aria-hidden="true" />
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-[#13261C]/40 backdrop-blur-sm data-[state=open]:animate-in data-[state=open]:fade-in-0" />
        <Dialog.Content
          className="fixed inset-y-0 right-0 z-50 w-full max-w-sm bg-cream shadow-2xl flex flex-col safe-top data-[state=open]:animate-in data-[state=open]:slide-in-from-right"
          style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
          data-testid="mobile-menu"
        >
          <div className="flex items-center justify-between h-[76px] safe-x">
            <Dialog.Title className="font-serif text-2xl text-forest">{t("brand")}</Dialog.Title>
            <Dialog.Close className="inline-flex items-center justify-center h-12 w-12 rounded-full hover:bg-cream-2" aria-label={t("nav.close")} data-testid="mobile-menu-close-button">
              <X className="h-6 w-6" aria-hidden="true" />
            </Dialog.Close>
          </div>
          <Dialog.Description className="sr-only">{t("nav.main")}</Dialog.Description>
          <nav aria-label={t("nav.main")} className="safe-x flex-1 pt-6">
            <ul className="flex flex-col">
              {items.map((i) => (
                <li key={i.key} className="border-b border-line">
                  <NavLink
                    to={i.to}
                    end={i.end}
                    onClick={() => setOpen(false)}
                    data-testid={`mobile-nav-link-${i.key}`}
                    className={({ isActive }) => `flex items-center min-h-[56px] font-serif text-[1.65rem] ${isActive ? "text-honey-ink" : "text-forest"}`}
                  >
                    {t(i.labelKey || `nav.${i.key}`)}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
          <LangSwitcher className="safe-x pt-6" testId="mobile-lang-switcher" onNavigate={() => setOpen(false)} />
          <BirdMark className="justify-center py-8" />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
